module.exports = __webpack_public_path__ + "img/planet-ringed.3a0b24bc.svg";